module.exports = require('./helpers/bundle-url').getBundleURL('at9U0') + "logo.c51670a8.svg";